import { FieldValues, RegisterOptions } from 'react-hook-form';

import { t } from '@gem/modules/i18n';

import { TValidationParams } from './validation.types';

export function requiredValidation<TFieldValues extends FieldValues = FieldValues>(
  message?: string | boolean,
  params?: TValidationParams
): RegisterOptions<TFieldValues> {
  if (params?.isDisabled) {
    return {};
  }

  const defaultMessage = t('common_required_field_error', { 0: '' });
  return {
    required: message ?? defaultMessage,
  };
}
